import React from 'react';
export default function NfseFiscalFields({ values = {}, onChange, disabled = false, inherit = false, issApplicable = true, issRequired = false }) {
  return <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
    {[
      ['NBS', 'nbs', 9], ['INDOP', 'indOp', 6], ['CST', 'cst', 3], ['CCLASSTRIB', 'cClassTrib', 6],
      ['Alíquota do ISS (%)', 'issRate', null], ['Simples Nacional (%)', 'simplesRate', null],
    ].map(([label, key, length]) => <label key={key} className="min-w-0 text-xs font-medium text-slate-700">{label}
      <input value={values[key] ?? ''} onChange={event => onChange(key, event.target.value)} disabled={disabled || (key === 'issRate' && !issApplicable)}
        required={key === 'issRate' && issRequired} inputMode={length ? 'numeric' : 'decimal'} maxLength={length || 6}
        placeholder={inherit ? 'Padrão geral' : ''}
        className="mt-1 block min-h-[42px] w-full rounded-lg border border-slate-200 bg-white px-3 py-2 text-sm focus:border-blue-400 disabled:opacity-50" />
    </label>)}
  </div>;
}
